import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { serviceProviderService } from '../../services/serviceProviderService';
import type { ServiceProvider } from '../../types/firestore';

export type CommunityProviderLoadState = 'not-applicable' | 'loading' | 'ready' | 'error';

export interface CommunityProviderState {
  provider: ServiceProvider | null;
  loadState: CommunityProviderLoadState;
}

export const useCommunityProviderState = (): CommunityProviderState => {
  const { currentUser, userProfile } = useAuth();
  const isServiceRole = userProfile?.role === 'serviceAdmin';
  const [state, setState] = useState<CommunityProviderState>(() => ({
    provider: null,
    loadState: isServiceRole ? 'loading' : 'not-applicable',
  }));

  useEffect(() => {
    let active = true;
    if (!isServiceRole || !currentUser?.uid) {
      setState({ provider: null, loadState: 'not-applicable' });
      return () => {
        active = false;
      };
    }

    setState({ provider: null, loadState: 'loading' });
    serviceProviderService
      .getServiceProviderProfile(currentUser.uid, { forceRefresh: true })
      .then((provider) => {
        if (active) setState({ provider, loadState: 'ready' });
      })
      .catch((error) => {
        console.error('Nie udało się potwierdzić dostępu serwisu do Community:', error);
        if (active) setState({ provider: null, loadState: 'error' });
      });

    return () => {
      active = false;
    };
  }, [currentUser?.uid, isServiceRole]);

  return state;
};
